<!--

  设置项通用组件

-->

<template>

  <!-- 分割线Item -->
  <div v-if="item.divider" class="divider"
       :style="{'background-color': item.bgColor, 'height': item.height + 'rem'}">
  </div>
  <!-- 标题Item -->
  <div v-else-if="item.isTitleItem" class="title-item-view">
    <img v-if="item.titleIcon" :src="item.titleIcon" class="title-icon-view">
    <div class="title-text-view">{{ item.title }}</div>
  </div>
  <!-- 列表项 -->
  <div v-else class="item-view" @click="item.onClick()">
    <!-- 左边 -->
    <div class="left-layout">
      <img v-if="item.icon" :src="item.icon" class="icon-view">
      <div class="left-view">
        <div class="title-layout">
          <div v-if="item.title" class="title-view">{{ item.title }}</div>
          <img v-if="item.tip" class="tip-view" :src="item.tip"
               :style="{'width': item.tipWidth + 'rem', 'height': item.tipHeight + 'rem'}"/>
        </div>
        <div v-if="item.desc || item.emptyDesc" class="desc-view">
          {{ item.desc ? item.desc : item.emptyDesc }}
        </div>
      </div>
    </div>
    <!-- 右边 -->
    <div class="right-view">
      <!-- 开关 --> <!-- v-model天坑，用value -->
      <custom_switch v-if="item.isSwitch" :value="item.switch" :touch="item.switchTouch"/>
      <!-- 文本 -->
      <div v-if="item.content">{{ item.content }}</div>
      <!-- 箭头 -->
      <img v-if="item.go" class="go-view" src="@/assets/arrow.png"/>
      <!-- 选项 -->
      <div @click.stop="item.onRadioClick()">
        <RadioView v-if="item.isChecked"
                   class="radio-view"
                   :checked="item.checked"/>
      </div>
    </div>
  </div>


</template>

<script>

import custom_switch from '@/components/widgets/Switch'
import RadioView from '@/components/widgets/RadioView'

export default {

  components: {
    RadioView,
    custom_switch
  },
  data () {
    return {
      value1: false
    }
  },
  props: {
    item: {}
  }
}
</script>

<style scoped>

.item-view {
  width: 100%;
  height: 5rem;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.left-layout {
  display: flex;
  flex-direction: row;
  justify-items: center;
  margin-right: 1rem;
}

.icon-view {
  width: 2.5rem;
  height: 2.5rem;
  margin-left: 0.8rem;

}

.left-view {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.8rem;
  flex: 1;
}

.title-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title-view {
  text-align: left;
  color: #151515;
  font-size: 1rem;
}

.desc-view {
  margin-top: 0.2rem;
  text-align: left;
  color: #999999;
  font-size: 0.8rem;
}

.tip-view {
  margin-left: 0.2rem;
}

.right-view {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-right: 1.2rem;
}

.go-view {
  width: 1.2rem;
  height: 1.2rem;
  /*margin-left: 0.1rem;*/
}

.radio-view {

}

.divider {
  width: 100%;
  height: 0.01rem;
  background-color: #FAFAFA;
}

.title-item-view {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  margin-right: 0.8rem;
  margin-left: 0.8rem;
  display: flex;
  align-items: center;
}

.title-icon-view {
  width: 1.2rem;
  height: 1.2rem;
}

.title-text-view {
  background-color: #FAFAFA;
  font-size: 0.8rem;
  color: #999999;
  text-align: left;
  margin-left: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/widgets/SettingItem.vue